import { AxiosResponse } from 'axios';

import { normalizePageData } from 'utils/commonNormalizer';
import { normalizeSearchFiltersPayload } from 'utils/filters';
import { prepareFormData } from 'utils/form';
import { IAllPageFilters, IPageType } from 'utils/types';

import axiosInstance from '../base';

import { METADATA_TEMPLATES_URL } from './constants';
import {
  normalizeMetadataTemplate,
  normalizeMetadataTemplatesMap,
  TMetadataTemplateData,
} from './normalizers';
import type {
  IMetadataTemplate,
  IMetadataTemplateForm,
  TMetadataTemplatesMap,
} from './types';

const metadataTemplatesAPI = {
  createMetadataTemplate: ({
    id: _id,
    ...payload
  }: IMetadataTemplateForm): Promise<AxiosResponse> =>
    axiosInstance.post(METADATA_TEMPLATES_URL, prepareFormData(payload)),

  getAllMetadataTemplate: async (
    filters: IAllPageFilters,
  ): Promise<IPageType<IMetadataTemplate>> => {
    const params = normalizeSearchFiltersPayload(filters);
    const response = await axiosInstance.get(METADATA_TEMPLATES_URL, { params });
    return normalizePageData<TMetadataTemplateData, IMetadataTemplate>(
      response.data,
      normalizeMetadataTemplate,
      JSON.stringify(filters.search),
    );
  },

  getMetadataTemplate: async (id: string): Promise<IMetadataTemplate> => {
    const response = await axiosInstance.get(`${METADATA_TEMPLATES_URL}/${id}`);
    return normalizeMetadataTemplate(response.data);
  },

  getMetadataTemplatesMap: async (
    filters?: IAllPageFilters,
  ): Promise<TMetadataTemplatesMap> => {
    const { search } = normalizeSearchFiltersPayload(filters);
    const response = await axiosInstance.get(`${METADATA_TEMPLATES_URL}/values`, {
      params: { includeGlobals: true, search },
    });
    return normalizeMetadataTemplatesMap(response.data);
  },

  removeMetadataTemplate: (id: number): Promise<AxiosResponse> =>
    axiosInstance.delete(`${METADATA_TEMPLATES_URL}/${id}`),

  updateMetadataTemplate: ({
    id,
    key,
    values,
  }: IMetadataTemplateForm): Promise<AxiosResponse> =>
    axiosInstance.put(
      `${METADATA_TEMPLATES_URL}/${id}`,
      prepareFormData({ key, values }),
    ),
};

export default metadataTemplatesAPI;
